import React, {createContext, useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import useApi, {IApiErreur} from "../../hooks/useApi";
import {add, addDays, format, isValid} from "date-fns";
import IUnite from "../../models/IUnite";
import "./calendrier.css";
import IReservationCalendrier from "../../models/IReservationCalendrier";
import Guid from "../../models/Guid";
import {useStorage} from "../../hooks/useStorage";
import {banSharp, logOutSharp} from "ionicons/icons";

import Toolbar from "devextreme-react/toolbar";
import PopupReserver from "./popup-reserver";
import PopupPage from "../../components/popups/PopupPage";
import GestionReservations from "../gestion-reservations/gestion-reservations";
import CalendrierTableauBord from "./calendrier-tableau-bord";
import PopupRenouveler from './popup-renouveler';
import ContextMenu from "devextreme-react/context-menu";
import GestionPaiement from "../gestion-paiement/gestion-paiement";
import MessageBox from "../../components/popups/MessageBox";
import CalendrierGrid from './calendrier-grid';
import CalendrierTabs from './calendrier-tabs';
import CalendrierLeftZone from './calendrier-left-zone';

import IUniteHorsServiceDates from "../../models/IUniteHorsServiceDates";
import IGestionReservation from "../../models/IGestionReservation";
import {ContextMenuRef} from "devextreme-react/context-menu";
import {ItemClickEvent} from "devextreme/ui/context_menu"
import {TypeAuxiliaire} from "../../models/TypeAuxiliaire";
import {useAuth} from "../../contexts/auth";
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";
import {ITypeUniteTabs, ISelectedCells, TypeCalendrier} from './calendrier-interfaces';
import {Item} from "devextreme-react/toolbar";
import {IAjoutReservationOption} from "../gestion-reservations/gestion-reservations";
import {utils} from "knockout";
import arrayForEach = utils.arrayForEach;

export enum CopyPasteMode {
    Copy,
    Cut
}

export interface IParamCopierColler {
    copyPasteMode: CopyPasteMode,
    typeAuxiliaireSource: TypeAuxiliaire,
    idAuxiliaireSource: Guid,
    idUniteDestination?: Guid,
    dateDestination?: Date,
    idUsager: Guid,
    idPosteEnregistrement?: Guid
}

export interface ICellUnitesDimensionCollection {
    [index: string]: ICellDimensionCollection
}

export interface ICellDimensionCollection {
    [index: string]: ICellDimension
}

export interface ICellDimension {
    OffsetTop?: number
    OffsetLeft?: number
    OffsetHeight?: number
    OffsetWidth?: number
}

export type CalendrierPropsContextType = {
    nbColonne: number;
    dateCourrante: Date;
    dateCourranteFin: Date;
    typeCalendrier: TypeCalendrier;
    calendrierData: IReservationCalendrier[] | undefined;
    unites: IUnite[] | undefined;
    selectedCell: ISelectedCells[];
    highlightedCell: ISelectedCells | undefined;
    selectedTypeUnite: ITypeUniteTabs | undefined;
    cellUnitesDimensions: ICellUnitesDimensionCollection;
    selectedReservation: IReservationCalendrier | undefined;
    isPopupReserverOpen: boolean;
    uniteHorsServiceDates: IUniteHorsServiceDates[] | undefined
    isLoading: boolean
    paramCopierColler?: IParamCopierColler;
    setCellUnitesDimensions: (idUnite: Guid | string, CellUnitesDimensionCollection: ICellUnitesDimensionCollection) => void;
    setSelectedCells: (props: ISelectedCells | undefined, e: React.MouseEvent<HTMLDivElement>) => void;
    setSelectedCellsBox: (props: ISelectedCells | undefined, e: React.MouseEvent<HTMLDivElement>) => void;
    removeInitialGroupCellState: () => void;
    setSelectedReservation: (id: IReservationCalendrier | undefined) => void;
    setIsPopupReserverOpen: (isOpen: boolean) => void
    setIsLoading: (isOpen: boolean) => void
    setIsPopupReservationOpen: (isOpen: boolean) => void
}

const CalendrierPropsContext = createContext<CalendrierPropsContextType>({
    nbColonne: 7,
    dateCourrante: new Date(),
    dateCourranteFin: new Date(),
    typeCalendrier: TypeCalendrier.Jours,
    calendrierData: [],
    unites: [],
    selectedCell: [],
    highlightedCell: undefined,
    selectedTypeUnite: undefined,
    selectedReservation: undefined,
    cellUnitesDimensions: {},
    isPopupReserverOpen: false,
    uniteHorsServiceDates: [],
    isLoading: false,
    paramCopierColler: undefined,
    setCellUnitesDimensions: (idUnite, cellUniteDimension) => {
    },
    setSelectedCells: (props: ISelectedCells | undefined) => {
    },
    setSelectedCellsBox: (props: ISelectedCells | undefined) => {
    },
    removeInitialGroupCellState: () => {
    },
    setSelectedReservation: (id) => {
    },
    setIsPopupReserverOpen: (isOpen: boolean) => {
    },
    setIsPopupReservationOpen: (isOpen: boolean) => {
    },
    setIsLoading: (isOpen: boolean) => {
    }
});

export enum TypeTabCalendrier {
    TypeUnite, GroupeTypeUnite, Carte
}

const Calendrier = (props: React.PropsWithChildren) => {
    const {data: unites, getData: getUnites, setData: setUnite, postData: postUnite} = useApi<IUnite[]>();
    const [selectedTypeUnite, setSelectedTypeUnite] = useStorage<ITypeUniteTabs>({key: "calendrier.selectedTypeUnite"});
    const {data: calendrierData, getData: getCalendrierData, setData: setCalendrierData} = useApi<IReservationCalendrier[]>("reservationdetail");
    const {data: uniteHorsServiceDates, getData: getUniteHorsServiceDates} = useApi<IUniteHorsServiceDates[]>()
    const [nbColonne, setNbColonne] = useState(7);
    const [typeCalendrier, setTypeCalendrier] = useState(TypeCalendrier.Jours);
    const [dateCourrante, setDateCourrante] = useState(new Date());
    const [dateCourranteFin, setDateFin] = useState(new Date());
    const [cellUnitesDimensions, setCellUnitesDimensionState] = useState<ICellUnitesDimensionCollection>({});
    const [selectedCell, setSelectedCellsState] = useState<ISelectedCells[]>([])
    const [selectedGroupCell, setSelectedGroupCellsState] = useState<ISelectedCells[]>([])
    const [highlightedCell, setHighlightedCell] = useState<ISelectedCells>()
    const [selectedReservation, setSelectedReservationState] = useState<IReservationCalendrier>()
    const [isPopRenouvelerOpen, setIsPopRenouvelerOpen] = useState(false);
    const [isPopupReserverOpen, setIsPopupReserverOpenState] = useState(false);
    const [isPopupReservationOpen, setIsPopupReservationOpenState] = useState(false);
    const [ajoutReservationOptions, setAjoutReservationOptions] = useState<IAjoutReservationOption | undefined>();
    const [isLoading, setIsLoadingState] = useState(false);
    const {postData: postReservation, fetchData: fecthReservation} = useApi<IGestionReservation>("reservation")
    const [refresh, setRefresh] = useState(false)
    const [paramCopierColler, setParamCopierColler] = useState<IParamCopierColler>();
    const {user} = useAuth();
    const [erreur, setErreur] = useState<IApiErreur>();
    const [isPopupVisibleDepot, setPopupVisibilityDepot] = useState(false);
    const contextMenuRef = useRef<ContextMenuRef>({} as ContextMenuRef);
    const [contextMenuOpened, setContextMenuOpened] = useState(false)
    const setCellUnitesDimensions = (idUnite: Guid | string, cellUnitesDimension: ICellUnitesDimensionCollection) => setCellUnitesDimensionState(prev => {
        return {
            ...prev, [`${idUnite}`]: {...prev[`${idUnite}`], ...cellUnitesDimension}
        }
    });
    const setIsLoading = (loading: boolean) => setIsLoadingState(loading);
    const [isMessageConfirmerAnnulationReservationOpen, setIsMessageConfirmerAnnulationReservationOpen] = useState(false);

    const groupSelect = useCallback((props: ISelectedCells, prevState: any, zone: any) => {
        const {idUnite, dates, ligne, colonne} = props;
        // const selectedCells: ISelectedCells[] = [];
        const selectedCells = [...prevState] as ISelectedCells[];
        const startColonne = Math.min(zone.colonne, colonne || 0);
        const endColonne = Math.max(zone.colonne, colonne || 0);
        const startLigne = Math.min(zone.ligne, ligne);
        const endLigne = Math.max(zone.ligne, ligne);

        for (let col = startColonne; col <= endColonne; col++) {
            for (let row = startLigne; row <= endLigne; row++) {
                const cell = document.querySelector(`[col-number="${col}"][row-number="${row}"]`);
                const cellDate = cell?.getAttribute("cell-date");
                const cellIdUnite = cellDate?.split("|")[0];
                const selectedDates = dates.map((date) => ({debut: addDays(date.debut, col - colonne), fin: addDays(date.debut, col - colonne)}));
                if (!selectedCells.some(f => f.idUnite.toString() == cellIdUnite && f.ligne == row && f.colonne == col))
                    selectedCells.push({idUnite: new Guid(cellIdUnite || ""), dates: selectedDates, ligne: row, colonne: col} as ISelectedCells);

            }
        }
        return selectedCells;
    }, [])

    const setSelectedCells = useCallback((props: ISelectedCells | undefined, e: React.MouseEvent<HTMLDivElement>) => {
        if (e.shiftKey && highlightedCell) {
            setSelectedCellsState(prevState => {
                if (!props) return [];
                return groupSelect(props, !e.ctrlKey ? [] : prevState, highlightedCell);
            });
        } else {
            setHighlightedCell(props || {} as ISelectedCells);
            setSelectedGroupCellsState(() => {
                if (!props) return [];
                return [props];
            })
            setSelectedCellsState(prevState => {
                if (!props) return [];
                const {idUnite, dates, ligne, colonne} = props;
                if (e.ctrlKey || e.shiftKey) {
                    if (prevState.some(cell => cell.colonne === colonne && cell.ligne === ligne))
                        return prevState.filter(cell => !(cell.colonne === colonne && cell.ligne === ligne));
                    else
                        return [...prevState, {idUnite, dates, ligne, colonne}] as ISelectedCells[];
                }
                return [{idUnite, dates, ligne, colonne}] as ISelectedCells[];
            })
            setSelectedReservationState(undefined);
        }
    }, [highlightedCell, groupSelect])

    const setSelectedCellsBox = useCallback((props: ISelectedCells | undefined, e: React.MouseEvent<HTMLDivElement>) => {
        if (e.ctrlKey || e.buttons === 1 || e.shiftKey) {
            if (e.shiftKey && e.buttons === 1) {
                setSelectedCellsState(prevState => {
                    if (!props) return [];
                    return groupSelect(props, [], highlightedCell);
                })
            } else if (selectedGroupCell[0]) {
                setSelectedCellsState(prevState => {
                    if (!props) return [];
                    return groupSelect(props, !e.ctrlKey ? [] : prevState, selectedGroupCell[0]);
                })
            }
        }
        setSelectedReservationState(undefined)
    }, [highlightedCell, selectedGroupCell, groupSelect])

    const removeInitialGroupCellState = () => {
        setSelectedGroupCellsState([]);
    }

    const setSelectedReservation = (id: IReservationCalendrier | undefined) => {
        setSelectedCellsState([])
        setSelectedReservationState(id);
    }

    const setIsPopupReserverOpen = (isOpen: boolean) => {
        setIsPopupReserverOpenState(isOpen);
    }

    const setIsPopupReservationOpen = (isOpen: boolean) => {
        setIsPopupReservationOpenState(isOpen);
    }

    const calendrierRef = useRef<any>(null);

    useEffect(() => {
        if (!selectedTypeUnite || !selectedTypeUnite.id) return;

        let dateDebut: Date;
        let dateFin: Date;
        if (selectedTypeUnite.typePeriode == TypeCalendrier.Jours) {
            dateDebut = dateCourrante
            dateFin = add(dateCourrante, {days: nbColonne});

        } else {
            dateDebut = new Date(dateCourrante.getFullYear(), dateCourrante.getMonth(), 1);
            if (selectedTypeUnite?.calDateDebut instanceof Date
                && selectedTypeUnite?.calDateFin instanceof Date) {
                const endingDate = calculateEndingDate(dateDebut, nbColonne, selectedTypeUnite.calDateDebut, selectedTypeUnite.calDateFin);
                dateFin = add(dateDebut, {months: endingDate});
            } else {
                dateFin = add(dateDebut, {months: nbColonne});
            }
        }
        if (selectedTypeUnite?.calDateDebut && selectedTypeUnite?.calDateFin) {
            dateDebut.setHours(selectedTypeUnite?.calDateDebut.getHours(), selectedTypeUnite?.calDateDebut.getMinutes(), selectedTypeUnite?.calDateDebut.getSeconds())
            dateFin.setHours(selectedTypeUnite?.calDateFin.getHours(), selectedTypeUnite?.calDateFin.getMinutes(), selectedTypeUnite?.calDateFin.getSeconds())
        }

        setSelectedReservation(undefined);
        setCalendrierData([]);
        getUniteHorsServiceDates({
            customPath: `typeunite/${selectedTypeUnite.id}/horsservice/?typeCalendrier=${selectedTypeUnite.type}&dateDebut=${format(dateDebut, "yyyy-MM-dd")}&dateFin=${format(dateFin, "yyyy-MM-dd")}`
        })
            .then(() => getCalendrierData({customPath: `reservationdetail/calendrier/${selectedTypeUnite?.id}?typeAuxiliaire=${selectedTypeUnite.type}&dateDebut=${format(dateDebut, "yyyy-MM-dd")}&dateFin=${format(dateFin, "yyyy-MM-dd")}`}));
        const currentDay = dateFin.getDate();
        dateFin.setDate(currentDay - 1);
        setDateFin(dateFin);
    }, [selectedTypeUnite, dateCourrante, nbColonne, refresh]);

    const onSelectionChange = useCallback(async (typeUnite: ITypeUniteTabs) => {
        if (!typeUnite) return;
        setUnite([]);
        setCellUnitesDimensionState({});
        setSelectedTypeUnite(typeUnite);
        setNbColonne(typeUnite?.nombreColonnes || 1)
        setTypeCalendrier(typeUnite?.typePeriode || 2)
        await getUnites({
            customPath: `${typeUnite?.type == TypeTabCalendrier.TypeUnite ? 'typeunite' : "typeunitegroupe"}/${typeUnite?.id}/unite`
        });
    }, [getUnites, setSelectedTypeUnite, setUnite])

    const onValueChanged = (props: any) => {
        setDateCourrante(props.value)
    };

    const navigateCalendrier = (move: number) => {
        setDateCourrante(prev => add(prev, {days: nbColonne * move}));
    }

    function calculateEndingDate(initialDate: Date, numColumns: number, calDateDebut: Date, calDateFin: Date) {
        let currentDate = new Date(initialDate);
        let visibleColumns = 0;
        let traversedMonths = 0;
        const startMonth = calDateDebut.getMonth();
        const endMonth = calDateFin.getMonth();

        const isMonthInSeason = (month: number) => {
            if (startMonth <= endMonth) {
                return month >= startMonth && month <= endMonth;
            }
            return month >= startMonth || month <= endMonth;
        }

        while (visibleColumns < numColumns) {
            if (isMonthInSeason(currentDate.getMonth())) {
                visibleColumns++;
            }

            traversedMonths++;

            if (visibleColumns >= numColumns) {
                break;
            }

            const nextDate = add(currentDate, {months: 1});
            if (!isValid(nextDate)) {
                break;
            }
            currentDate = nextDate;
        }

        return traversedMonths;
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Escape') {
            setSelectedGroupCellsState([]);
            setSelectedCellsState([]);
            setHighlightedCell(undefined);
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown); // Detach the event listener when the component unmounts
        };
    }, []);

    const onContextMenuItemClick = useCallback((e: ItemClickEvent) => {
        if (e.itemData?.text == "Réserver") {
            setIsPopupReserverOpenState(true)
        }
    }, [])

    const copierButtonOptions = useMemo(() => ({
        text: "Copier", icon: "copy", disabled: !selectedReservation || selectedReservation?.reservationBloquee, onClick: () => {
            if (selectedReservation && selectedReservation?.idReservationDetail)
                setParamCopierColler({
                    dateDestination: undefined,
                    idPosteEnregistrement: undefined,
                    idUniteDestination: undefined,
                    idUsager: user?.idUsager || Guid.empty,
                    typeAuxiliaireSource: TypeAuxiliaire.ReservationDetail,
                    idAuxiliaireSource: selectedReservation?.idReservationDetail,
                    copyPasteMode: CopyPasteMode.Copy
                });
        }
    }), [selectedReservation, user?.idUsager]);
    const canPaste = useMemo(() => paramCopierColler?.idAuxiliaireSource &&
            !paramCopierColler?.idAuxiliaireSource.isEmpty() &&
            (!selectedReservation?.idReservationDetail ||
                selectedReservation?.idReservationDetail.isEmpty()),
        [paramCopierColler?.idAuxiliaireSource, selectedReservation?.idReservationDetail]);

    const btnRechercheOptions = useMemo(() => ({text: "Rechercher"}), []);
    const btnReserverOptions = useMemo(() => ({text: "Réserver", icon: "plus", disabled: selectedReservation !== undefined, onClick: () => setIsPopupReserverOpen(true)}), [selectedReservation]);
    const btnModifierOptions = useMemo(() => ({text: "Modifier la réservation", disabled: !selectedReservation, icon: "edit", onClick: () => setIsPopupReservationOpen(true)}), [selectedReservation]);

    const btnCouperOptions = useMemo(() => ({
        text: "Couper", icon: "cut", disabled: !selectedReservation || selectedReservation?.reservationBloquee, onClick: () => {
            if (selectedReservation && selectedReservation?.idReservationDetail)
                setParamCopierColler({
                    dateDestination: undefined,
                    idPosteEnregistrement: undefined,
                    idUniteDestination: undefined,
                    idUsager: user?.idUsager || Guid.empty,
                    typeAuxiliaireSource: TypeAuxiliaire.ReservationDetail,
                    idAuxiliaireSource: selectedReservation?.idReservationDetail,
                    copyPasteMode: CopyPasteMode.Cut
                });
        }
    }), [selectedReservation, user?.idUsager]);

    const collerOnclick = useCallback(() => {
        const firstSelectedCell = selectedCell.find(f => true);
        const firstDateDebut = firstSelectedCell?.dates.find(f => true)?.debut;
        fecthReservation("post", {
            body: {...paramCopierColler, idUniteDestination: firstSelectedCell?.idUnite, dateDestination: firstDateDebut} as IParamCopierColler,
            customPath: "reservation/coller",
            returnOnly: true
        }).then((res) => {
            if ("errorMessage" in res) {
                setErreur(res);
            } else {
                setParamCopierColler(undefined);
                setRefresh((prev) => !prev)
            }
        })
    }, [selectedCell, fecthReservation, paramCopierColler]);

    const btnCollerOptions = useMemo(() => ({
        text: "Coller", icon: "paste", disabled: !canPaste, onClick: collerOnclick
    }), [canPaste, collerOnclick]);

    const erreurPopupOkButtonOption = useMemo(() => {
        return {
            text: "Ok",
            onClick: () => {
                setErreur(undefined);
            }
        }
    }, [])

    const btnAnnulerReservationOptions = useMemo(() => ({
        text: "Annuler réservation",
        icon: "remove",
        disabled: !selectedReservation,
        onClick: () => {
            setIsMessageConfirmerAnnulationReservationOpen(true);
        }
    }), [selectedReservation]);

    const btnBloqueronClick = useCallback(() => {
        fecthReservation("put", {
            body: {idReservationDetail: selectedReservation?.idReservationDetail, bloquer: !selectedReservation?.reservationBloquee},
            customPath: "reservation/bloquerDetail",
            returnOnly: true
        }).then(() => setRefresh((prev) => !prev))
    }, [fecthReservation, selectedReservation?.idReservationDetail, selectedReservation?.reservationBloquee]);

    const btnDepartOptions = useMemo(() => ({text: "Départ", icon: logOutSharp, disabled: !selectedReservation}), [selectedReservation]);

    const btnBloquerOptions = useMemo(() => ({
            text: selectedReservation?.reservationBloquee ? "Débloquer" : "Bloquer",
            icon: banSharp,
            onClick: btnBloqueronClick,
            disabled: !selectedReservation?.idReservationDetail || selectedReservation?.idReservationDetail.isEmpty()
        }),
        [selectedReservation?.reservationBloquee, btnBloqueronClick, selectedReservation?.idReservationDetail]);
    const btnDepotOtions = useMemo(() => ({
        text: "Dépôt", icon: "money", disabled: !selectedReservation, onClick: () => {
            setPopupVisibilityDepot(true)
        }
    }), [selectedReservation]);

    const contextMenuitems = useMemo(() => [
        btnReserverOptions,
        btnModifierOptions,
        {...copierButtonOptions, beginGroup: true},
        btnCouperOptions,
        btnCollerOptions,
        btnBloquerOptions,
        btnDepartOptions,
        btnAnnulerReservationOptions,
        btnDepotOtions,
        {text: "Facturer"},
        {
            text: "Mettre hors-service", icon: "minus", beginGroup: true, onClick: async () => {
                const selectedDatesByUnite = selectedCell.reduce<{
                    idUnite: Guid;
                    dates: {
                        debut: Date;
                        fin: Date;
                    }[];
                }[]>((acc, cell) => {
                    const existingUnite = acc.find(unite => unite.idUnite.equals(cell.idUnite));

                    if (existingUnite) {
                        existingUnite.dates.push(...cell.dates);
                    } else {
                        acc.push({
                            idUnite: cell.idUnite,
                            dates: [...cell.dates]
                        });
                    }

                    return acc;
                }, []);
                selectedDatesByUnite.forEach(async (selectedDatesByUnite) => {
                    await postUnite({selectedDatesByUnite}, `unite/${selectedDatesByUnite.idUnite}/horsServices`, true);
                })

            }
        },
        {text: "Renouveler", beginGroup: true},
    ], [copierButtonOptions, btnCouperOptions, btnCollerOptions, btnAnnulerReservationOptions, btnDepartOptions, btnReserverOptions, btnBloquerOptions, btnDepotOtions, btnModifierOptions]);

    const onContextMenuShown = useCallback(() => setContextMenuOpened(true), []);
    const onContextMenuHidden = useCallback(() => setContextMenuOpened(false), []);

    const onConfirmeAnnulerReservation = useCallback(() => {
        fecthReservation("put", {
            body: {
                idReservationEntete: selectedReservation?.idReservationEntete,
                idUsagerAnnulation: user?.idUsager,
                annuler: true
            },
            customPath: "reservation/annulerReservation",
            returnOnly: true
        }).then((res) => {
            if ("errorMessage" in res) {
                setErreur(res);
            } else {
                setRefresh((prev) => !prev)
            }
        })
        setIsMessageConfirmerAnnulationReservationOpen(false)
    }, [selectedReservation?.idReservationEntete, fecthReservation, user?.idUsager]);

    const messageBoxAnnulerReservationonAnnuler = useCallback(() => setIsMessageConfirmerAnnulationReservationOpen(false), []);

    const btnRenouveller = useMemo(() => ({text: "Renouveler", onClick: () => selectedReservation?.idReservationEntete ? setIsPopRenouvelerOpen(!isPopRenouvelerOpen) : null}), [selectedReservation?.idReservationEntete]);
    const btnFacturerOptions = useMemo(() => ({text: "Facturer"}), []);
    const btnFicheReservationOptions = useMemo(() => ({text: "Fiche réservation"}), []);
    const btnImprimerCalendrierOptions = useMemo(() => ({text: "Impression calendier"}), []);
    const calendrierStyle = useMemo(() => ({padding: "1rem", height: "100%"}), []);
    return (
        <div style={calendrierStyle} id={"calendrier"} ref={calendrierRef}>
            <CalendrierPropsContext.Provider value={{typeCalendrier, unites, selectedTypeUnite, calendrierData, nbColonne, dateCourrante, dateCourranteFin, isLoading, cellUnitesDimensions, selectedReservation, selectedCell, highlightedCell, isPopupReserverOpen, paramCopierColler, uniteHorsServiceDates, setCellUnitesDimensions, setSelectedCells, setSelectedCellsBox, removeInitialGroupCellState, setSelectedReservation, setIsPopupReserverOpen, setIsPopupReservationOpen, setIsLoading}} {...props} >
                <MessageBox title={"Annulation de réservation"} message={`Êtes-vous sûr de vouloir annuler la réservation ${selectedReservation?.noConfirmation}`} buttonType={"OuiNon"} onConfirme={onConfirmeAnnulerReservation} onAnnuler={messageBoxAnnulerReservationonAnnuler} isOpen={isMessageConfirmerAnnulationReservationOpen}/>
                <Popup visible={erreur != undefined} width={"500px"} height={"auto"} title={"Erreur"}>
                    <Position my="center" collision="fit"/>
                    <div dangerouslySetInnerHTML={{__html: erreur?.errorMessage.replace("\r\n", "<br>") || ""}}/>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="center"
                        options={erreurPopupOkButtonOption}
                    />
                </Popup>
                {isPopupReserverOpen ? <PopupReserver isPopupOpen={isPopupReserverOpen} onClose={() => setIsPopupReserverOpenState(false)} onReserver={(ajoutReservationOption) => {
                    setAjoutReservationOptions(ajoutReservationOption);
                    setIsPopupReservationOpenState(true)
                }}/> : null}
                {isPopupReservationOpen ? <PopupPage titre={"Information de réservation"} isPopupOpen={isPopupReservationOpen} onClose={() => {
                    setAjoutReservationOptions(undefined);
                    setIsPopupReservationOpenState(false)
                    setRefresh((prev) => !prev)
                }} width={"100%"} height={"100%"} mode={"ajout"}>
                    <GestionReservations ajoutReservationOption={ajoutReservationOptions} idReservationEntete={selectedReservation && selectedReservation?.idReservationEntete} collapseListe={true}/>
                </PopupPage> : null}
                {isPopupVisibleDepot ? <PopupPage
                    titre="Dépôt"
                    isPopupOpen={isPopupVisibleDepot}
                    onClose={(value) => {
                        setPopupVisibilityDepot(false);
                        setRefresh(prev => !prev)
                    }}
                    mode={"ajout"}
                    height={"60%"}
                    width={"60%"}
                >
                    <GestionPaiement id={selectedReservation?.idReservationEntete} typeAuxiliaire={TypeAuxiliaire.Reservation} montantAuxiliaireTotal={0}/>
                </PopupPage> : null}
                {isPopRenouvelerOpen ? <PopupRenouveler isPopupOpen={isPopRenouvelerOpen} onClose={(): void => {
                    setIsPopRenouvelerOpen(!isPopRenouvelerOpen);
                }} onRenouvele={(): void => {
                    throw new Error('Function not implemented.');
                }}/> : null}
                <div className={"calendrier-main-container"}>
                    <div className={"classement-main-section"}>
                        <CalendrierLeftZone dateCourrante={dateCourrante} onValueChanged={onValueChanged}/>
                        <div className={"calendrier-main"}>
                            <div className={"calendrier-toolbar"}>
                                <CalendrierTabs onSelectionChange={onSelectionChange}/>
                                <Toolbar>
                                    <Item location={"before"} widget={"dxButton"} options={btnRechercheOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnReserverOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnModifierOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={copierButtonOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnCouperOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnCollerOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnBloquerOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnDepartOptions}/>
                                    <Item location={"before"} locateInMenu={"auto"} widget={"dxButton"} options={btnRenouveller}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnAnnulerReservationOptions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnDepotOtions}/>
                                    <Item location={"before"} widget={"dxButton"} options={btnFacturerOptions}/>
                                    <Item location={"before"} locateInMenu={"auto"} widget={"dxButton"} options={btnFicheReservationOptions}/>
                                    <Item location={"before"} locateInMenu={"auto"} widget={"dxButton"} options={btnImprimerCalendrierOptions}/>
                                </Toolbar>
                            </div>
                            <CalendrierGrid
                                idReservationEntete={selectedReservation?.idReservationEntete}
                                isCarte={selectedTypeUnite?.description === 'carte'}
                                handleKeyDown={handleKeyDown}
                                calendrierData={calendrierData}
                                selectedTypeUniteId={selectedTypeUnite?.id}
                                selectedCell={selectedCell}
                                navigateCalendrier={navigateCalendrier}
                                contextMenuRef={contextMenuRef}
                                contextMenuOpened={contextMenuOpened}
                                setContextMenuOpened={setContextMenuOpened}
                            />
                            {/* <ContextMenu ref={contextMenuRef} target={"#calendrier-grid"} items={contextMenuitems} onItemClick={onContextMenuItemClick} hoverStateEnabled={true} onShown={onContextMenuShown} onHidden={onContextMenuHidden} /> */}
                        </div>
                    </div>
                    <CalendrierTableauBord/>
                </div>
            </CalendrierPropsContext.Provider>
            <ContextMenu ref={contextMenuRef} target={"#calendrier-grid"} items={contextMenuitems} onItemClick={onContextMenuItemClick} hoverStateEnabled={true} onShown={onContextMenuShown} onHidden={onContextMenuHidden}/>
        </div>);
}
export default Calendrier;

const useCalendrierProps = () => useContext(CalendrierPropsContext);
export {useCalendrierProps};